import React from 'react'
import ErrorBoundary from '../../../Error/widgets/ErrorBoundary'
import translate from '../../../../modules/translate'
import SkeletonDepartment from '../../components/ListDepartment/skeleton'
import ListDepartment from '../../components/ListDepartment'

const errorOptions = {
  component: translate('department'),
  link: '/',
  linkText: translate('error_try_homepage'),
  logError: 'Department screen display',
}

const ScreenDepartment = ({ loading, error, response: { data }, ready, ...props }) => {


  return(
  <ErrorBoundary error={error} {...errorOptions} {...props}>
    {loading && <SkeletonDepartment {...props} />}
    {data && <ListDepartment data={data} {...props} />}
  </ErrorBoundary>
)}

ScreenDepartment.defaultProps = {
  response: {
    data: undefined,
  },
}

export default ScreenDepartment
